import React from 'react';
//import { assets } from '../assets/assets';
import './About.css';

const About = () => {
  return (
    <div className="about-container">

      <div className="about-heading">
        <p>ABOUT <span className="highlight-text">US</span></p>
      </div>

      <div className="about-content">
        <img className="about-image"  src="/Images/card-image-6.webp" alt="" />

        <div className="about-text">
          <p>
            Lushio Fitness is Lushio&apos;s premium fitness wear brand, created
            for people who want performance, comfort, and clean everyday style
            in a single wardrobe. From activewear essentials to athleisure
            staples, it is designed for movement on the gym floor and
            confidence beyond it.
          </p>
          <p>
            Our mission is to create thoughtfully designed apparel that feels as
            strong as it looks. We focus on quality fabrics, functional fits,
            and a premium finish so every piece can support training, travel,
            recovery, and daily wear.
          </p>
          <b className="about-subheading">Our Vision</b>
          <p>
            We envision Lushio as a modern fitness wear label from India that
            stands for elevated essentials, movement-first design, and a strong
            lifestyle identity. Our goal is to build apparel people are proud to
            wear in the gym, on the street, and everywhere in between.
          </p>
        </div>
      </div>

      <div className="why-choose-heading">
        <p>WHY <span className="highlight-text-bold">CHOOSE US</span></p>
      </div>

      <div className="why-choose-container">
        <div className="why-box">
          <b>PREMIUM BUILD:</b>
          <p>Well-made activewear and athleisure pieces crafted for long-term comfort and repeat wear.</p>
        </div>

        <div className="why-box">
          <b>MOVE FREELY:</b>
          <p>Fits and fabrics selected to support workouts, daily routines, and the full fitness lifestyle.</p>
        </div>

        <div className="why-box">
          <b>MODERN FITNESS STYLE:</b>
          <p>Clean silhouettes and versatile designs that make Lushio wearable inside and outside the gym.</p>
        </div>
      </div>
    </div>
  );
};

export default About;
